import React from 'react';

const MemberIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="32"
    viewBox="0 0 29 32"
  >
    <g fill="none">
      <path d="M0.1 27.3C0.1 28.7 1.4 29.7 4.1 30.4 6.7 31.2 10 31.6 14.1 31.6 18.2 31.6 21.6 31.2 24.2 30.4 26.8 29.7 28.1 28.7 28.1 27.3 28.1 25.9 27.4 24.5 25.9 23.3 24.4 22.1 22.4 21.2 20 20.6 21.5 19.6 22.6 18.3 23.4 16.6 24.3 15 24.7 13.2 24.7 11.3 24.7 8.2 23.6 5.6 21.6 3.4 19.4 1.3 16.9 0.2 13.9 0.2 11 0.2 8.5 1.3 6.4 3.4 4.2 5.6 3.2 8.2 3.2 11.3 3.2 13.2 3.6 15 4.5 16.7 5.4 18.3 6.6 19.6 8.1 20.6 5.7 21.3 3.8 22.2 2.3 23.4 0.9 24.5 0.1 25.9 0.1 27.3Z" />
    </g>
  </svg>
);

export default MemberIcon;
